var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"value"},[(_vm.data == null)?_c('i',{staticClass:"el-icon-loading"}):_vm._t("default",[_vm._v(_vm._s(_vm.getValue())+_vm._s(_vm.suffix))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }